import { FollowConditions } from 'api';

export const ASSET_KEYS = [
  'required_groups',
  'suggested_groups',
  'required_users',
  'suggested_users',
];

export const FOLLOW_KEYS = ['follow_conditions.location_id', 'follow_conditions.department_id'];

export const ALL_MAPPING_KEYS = ASSET_KEYS.concat(FOLLOW_KEYS);

export const EMPTY_FOLLOW_CONDITIONS: FollowConditions = {
  locations: [],
  location_id: [],
  departments: [],
  department_id: [],
};
